define.alias("ember-composable-helpers/helpers/contains", "settings/helpers/contains");